import React, { useState, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import { useColumnsMemo } from './parsecolumns';
import TableSubHeader from './subheader';
import { useFilterMemo } from './usefilter';
import config from './config';
import { resolveCondition } from '../../condition';
import { useReducer } from 'react';
import { asBool } from '../../form/input/utils';
import { isValid } from '../../utils';

const solverfn = (local) => (condition, style) => {
	const result = resolveCondition(condition, { local });
	const ishidden = (result === "hide" || !result) ? { style: { display: "none", ...style } } : { style }
	const isdisabled = result === "disable" ? { disabled: true } : {}
	return { ...ishidden, ...isdisabled }
}


const TableElement = ({ data, title, hasClickActions, selectable, hasButtons, click, pagination, buttons: ActionList, ...props }) => {
	const columns = useColumnsMemo(props);
	const [filteredData, filterText, setFilter] = useFilterMemo({ data, ...props });
	const [selected, setSelected] = useState({ selectedRows: [] });
	const buttonShouldDisplay = useMemo(() => solverfn({ selected: selected.selectedRows }), [selected])
	const [clearState, clear] = useReducer(state => !state, true)

	const dataTableConfig = useMemo(() => {
		const dtConfig = { ...config }

		if (pagination instanceof Array) {
			dtConfig.pagination = !!pagination.length
			dtConfig.paginationRowsPerPageOptions = pagination.map(opt => parseInt(opt))
			dtConfig.paginationPerPage = dtConfig.paginationRowsPerPageOptions[0]
			dtConfig.paginationComponentOptions = { ...config.paginationComponentOptions }
			dtConfig.paginationComponentOptions.noRowsPerPage = pagination.length === 1
		} else if ((typeof pagination === "string" && pagination.split(";").every(opt => !isNaN(parseInt(opt)))) || (typeof pagination === "number" && pagination > 1)) {
			dtConfig.pagination = !!pagination
			dtConfig.paginationRowsPerPageOptions = pagination.toString().split(";").map(opt => parseInt(opt))
			dtConfig.paginationPerPage = dtConfig.paginationRowsPerPageOptions[0]
			dtConfig.paginationComponentOptions = { ...config.paginationComponentOptions }
			dtConfig.paginationComponentOptions.noRowsPerPage = pagination.toString().split(";").length === 1
		} else if (isValid(pagination)) {
			dtConfig.pagination = asBool(pagination)
		}

		return dtConfig;
	}, [pagination])

	return (
		<React.Fragment>
			<div className="card-body p-0">
				<DataTable
					title={title}
					columns={columns}
					data={filteredData}
					actions={<TableSubHeader data={filteredData} title={title} filter={filterText} onFilter={setFilter} {...props} />}
					subHeader={false}
					defaultSortField={undefined}
					pointerOnHover={hasClickActions}
					onRowClicked={row => click(row)()}
					selectableRows={hasButtons && asBool(selectable)}
					clearSelectedRows={clearState}
					expandableRows={false}
					noDataComponent={<p className="m-3" >Sin registros disponibles</p>}
					progressPending={false}
					onSelectedRowsChange={setSelected}
					{...dataTableConfig}
					pagination={true}
					style={({ overflowX: "none" })}
				/>
			</div>
			<div className="card-footer">
				<div className="form-row justify-content-md-end">
					<ActionList data={({ selected: selected.selectedRows })} close={clear} isDisabled={props.isDisabled} solver={buttonShouldDisplay} processingFlagPath={props.processingFlagPath} />
				</div>
			</div>
		</React.Fragment>
	);
};

export default TableElement;

